import type {StreamCamera} from '@/entities/stream/types';

function sameName(a: string, b: string): boolean {
  return a.trim().toLocaleLowerCase() === b.trim().toLocaleLowerCase();
}

/**
 * Is this catalogue camera the terminal's own video? A terminal streams as a camera
 * "added by hand", which gets its own `cam-…` id, so the link is the NAME the cabinet
 * gave it (the terminal's). A future native source would have `peer` = `SVFID-…` or
 * the device id; those are accepted too.
 */
export function matchesTerminal(camera: StreamCamera, ids: string[], name?: string): boolean {
  return (
    ids.some(id => camera.peer === id || camera.deviceId.startsWith(`${id}:`)) ||
    (!!name && sameName(camera.name, name))
  );
}
